// The shell the receiving forms, the vendor forms and about forty other modals open in. It is the
// kit's Dialog, mounted open: the parent decides when it exists, so a parent that drops it still
// gets focus handed back. A child names the field it wants focused with `data-drawer-autofocus`
// (React's own autoFocus loses the race), and Dialog honours the marker.

import React from 'react';
import Dialog from '../components/ui/Dialog';

interface Props {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  // Width hint; defaults to the receive-drawer size. 'lg' is for forms with a
  // wider layout (e.g. VendorsAdmin's edit form, VendorPreviewModal).
  size?: 'md' | 'lg';
  // Typed work would be lost: Escape, the scrim and the close key ask before closing.
  dirty?: boolean;
}

const DrawerShell: React.FC<Props> = ({ title, onClose, children, size = 'md', dirty }) => (
  <Dialog open title={title} onClose={onClose} size={size === 'lg' ? 'xl' : 'lg'} dirty={dirty}>
    {children}
  </Dialog>
);

export default DrawerShell;
